export function pause(ms, signal) {
  return new Promise((resolve, reject) => {
    const abort = () => { clearTimeout(timer); signal?.removeEventListener('abort', abort); reject(Object.assign(new Error('Presentation cancelled'), { name: 'AbortError' })); };
    let timer;
    if (signal?.aborted) { abort(); return; }
    timer = setTimeout(() => { signal?.removeEventListener('abort', abort); resolve(); }, ms);
    signal?.addEventListener('abort', abort, { once: true });
  });
}
export async function presentCommand(command, show, { reduced = false, signal, sound } = {}) {
  for (const frame of command.presentation || []) {
    if (signal?.aborted) throw Object.assign(new Error('Presentation cancelled'), { name: 'AbortError' });
    show(frame.round);
    try { sound?.(frame.type, frame.round); } catch { /* decorative */ }
    const duration = { card: 560, reveal: 500, split: 330, settle: 220, start: 100 }[frame.type] || 90;
    await pause(reduced ? 15 : duration, signal);
  }
  if (signal?.aborted) throw Object.assign(new Error('Presentation cancelled'), { name: 'AbortError' });
  show(command.round);
}
